<template>
  <div v-if="viewTemplate && brands" class="layout-brands-carousel">
    <div class="header">
      <div class="title s-48 w-600">В нашем магазине представлены товары лучших брендов</div>
      <div class="subtitle s-18">Время сна сотрудничает с лучшими мировыми брендами в области товаров для сна!</div>
      <!--  -->
    </div>
    <div class="container">
      <Carousel autoplay loop :per-page-custom="[[0,2],[768,7]]">
        <Slide
            v-for="(brand, key, index) in brands"
            :key="key"
        >
          <img :src="brand.imgurl" :alt="brand.name" :title="brand.name" >
        </Slide>
      </Carousel>
    </div>
  </div>
</template>

<script>
import { Slide, Carousel } from 'vue-carousel'
export default {
  components: {
    Slide,
    Carousel
  },
  data() {
    return {
      viewTemplate: false,
      brands: []
    }
  },
  created() {
    window.addEventListener('scroll', () => {
      if(!this.viewTemplate && pageYOffset > 200){
        this.viewTemplate = true;
        this.requestBrand();
      }
    });
  },
  methods:{
    requestBrand(){
      this.$axios({
        url: '/ajax/brands.php',
        headers: {'Content-Type': 'application/json'},
        method: 'post',
        data: {
          site_id: this.$store.state.siteid,
          template_site: this.$store.state.langs.TEMPLATE_SITE
        }
      }).then(response => {
        if (response.status == 200) {
          this.brands = response.data;
        }
      }).catch(e => {
        console.log('Error: ' + e)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.layout-brands-carousel {
  text-align: center;
  margin: 5em 0;
}
img {
  height: 1em;
  width: auto;
}
.header {
  width: 46em;
  max-width: 100%;
  position: relative;
  margin: 0 auto;
}
.subtitle {
  margin-top: 2em;
}
.container {
  margin-top: 6em;
}

@media screen and (max-width: 767px) {
  .header {
    width: unset;
    padding: 0 var(--gap);
  }
}
</style>

<style lang="scss">
.layout-brands-carousel {
  img {
    height: 1.5em;
    width: auto;
  }
}
</style>
